/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_036: Question = {
  id: 'pres-036-habitats-zonage-urbanisme',
  oldId: '50',
  title: 'Intégration des habitats fauniques et floristiques d’intérêt dans le règlement de zonage et autres règlements d’urbanisme et plan d\'urbanisme (PU)',
  number: '3.20',
  description: [''],
  type: QuestionType.ACTIVITY,
  frequency: 3,
  idEM: 4,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: true,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

export const question_pres_036_v2: Question = question_pres_036;
export const question_pres_036_v3: Question = question_pres_036;
